<template>
  <v-container
    class="fill-height"
  >
    <v-row>
      <v-col>
        <!-- page header -->
        <page-header />
        <!-- login or goodbye form, determined by router -->
        <v-row>
          <router-view />
        </v-row>
        <!-- spinner with overlay if auth pending -->
        <v-overlay :value="authIsPending">
          <v-progress-circular
            :size="size"
            :width="width"
            indeterminate
          />
        </v-overlay>
        <!-- about / extra links at the bottom of the page  -->
        <about />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { vxm } from '../../state/index'
import PageHeader from './components/PageHeader.vue'
import About from './components/About.vue'

export default {
  name: 'LogInPage',
  components: {
    PageHeader,
    About,
  },
  data: () => ({
  }),
  computed: {
    authIsPending() {
      return vxm.authUser.authIsPending
    },
    size() {
      switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return '120'
      case 'sm':
        return '120'
      case 'md':
        return '140'
      case 'lg':
        return '140'
      case 'xl':
        return '160'
      default:
        return '100'
      }
    },
    width() {
      switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return '8'
      case 'sm':
        return '8'
      case 'md':
        return '10'
      case 'lg':
        return '10'
      case 'xl':
        return '10'
      default:
        return '10'
      }
    },
  },
}
</script>

<style></style>
